export default "__VITE_ASSET__e9d22661__"